import { useEffect, useState } from "react";
import AppShell from "../components/AppShell";
import api from "../lib/api";

export function FeedbackPanel() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get("/admin/cancel-feedback").then(({ data }) => setData(data)).catch((e) => setErr(e.response?.data?.detail || "Couldn't load"));
  }, []);

  return (
    <div data-testid="owner-feedback">
      {err && <div className="text-sm text-[#FF3B30]" data-testid="feedback-error">{err}</div>}
      {data && (
        <>
          <div className="flex flex-wrap mb-8" data-testid="feedback-counts">
            <div className="bg-white p-5 min-w-[160px] border border-zinc-200 -mr-px -mb-px"><div className="text-4xl font-black" data-testid="feedback-total">{data.total}</div><div className="text-xs uppercase tracking-wider text-zinc-500 mt-1">Total answers</div></div>
            {Object.entries(data.counts).sort((a, b) => b[1] - a[1]).map(([r, n]) => (
              <div key={r} className="bg-white p-5 min-w-[160px] border border-zinc-200 -mr-px -mb-px"><div className="text-3xl font-black text-[#0033FF]">{n}</div><div className="text-xs uppercase tracking-wider text-zinc-500 mt-1">{r}</div></div>
            ))}
          </div>
          <div className="border border-zinc-200 divide-y divide-zinc-200" data-testid="feedback-list">
            {data.items.length === 0 && <div className="p-6 text-sm text-zinc-500" data-testid="feedback-empty">No answers yet.</div>}
            {data.items.map((f) => (
              <div key={f.id} className="p-5" data-testid={`feedback-item-${f.id}`}>
                <div className="flex flex-wrap items-center justify-between gap-2">
                  <div className="font-bold text-sm">{f.reason || "No reason picked"}</div>
                  <div className="text-xs text-zinc-500 font-mono">{new Date(f.created_at).toLocaleString()}</div>
                </div>
                <div className="text-xs text-zinc-500 mt-1">{f.name} · {f.email} · left {f.from_plan?.toUpperCase()}</div>
                {f.comment && <p className="text-sm text-zinc-700 mt-2">"{f.comment}"</p>}
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

export default function AdminFeedback() {
  return <AppShell eyebrow="App owner" title="Why people leave"><FeedbackPanel /></AppShell>;
}
